import { msgTypes } from 'constants/msgTypes'
import React from 'react'

const WebsiteMenu = () => {
  return (
    <nav className="navbar navbar-expand-lg blur blur-rounded top-0 z-index-3 shadow position-absolute my-3 p-0 start-0 end-0 navbar-expand-section">
        <div className="container navbar-toggler-btn">
          {/* <a className="navbar-brand" href="#">Navbar w/ text</a> */}
          <button className=" navbar-toggler shadow-none ms-2" type="button" data-bs-toggle="collapse" data-bs-target="#navigation" aria-controls="navigation" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon mt-2">
              <span className="navbar-toggler-bar bar1"></span>
              <span className="navbar-toggler-bar bar2"></span>
              <span className="navbar-toggler-bar bar3"></span>
            </span>
          </button>
          <div className="collapse navbar-collapse w-100 pt-3 pb-2 py-lg-0" id="navbarText">
            <ul className="navbar-nav navbar-nav-hover mx-auto">
              <li className="nav-item dropdown dropdown-hover mx-3">
                <a className="nav-link ps-2 d-flex justify-content-between cursor-pointer align-items-center" target="_blank" href={msgTypes.WEBSITE_URL.HOME}>Home<span className="sr-only">(current)</span></a>
              </li>
              <li className="nav-item dropdown dropdown-hover mx-3">
                <a className="nav-link ps-2 d-flex justify-content-between cursor-pointer align-items-center" target="_blank" href={msgTypes.WEBSITE_URL.ABOUT}>About</a>
              </li>
              <li className="nav-item dropdown dropdown-hover mx-3">
                <a className="nav-link ps-2 d-flex justify-content-between cursor-pointer align-items-center dropdown-toggle" target="_blank" href={msgTypes.WEBSITE_URL.MEMBERSHIP_BENEFITS} id="membershipDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Membership Benefits
                </a>
                <ul className="drop-one dropdown-menu" aria-labelledby="membershipDropdown">
                  <li><a className="dropdown-item" target="_blank" href={msgTypes.WEBSITE_URL.MEMBERSHIP_REGISTRATION}>Membership Registration</a></li>
                </ul>
              </li>
              <li className="nav-item dropdown dropdown-hover mx-3">
                <a className="nav-link ps-2 d-flex justify-content-between cursor-pointer align-items-center" target="_blank" href={msgTypes.WEBSITE_URL.CONTACT_US}>Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
  )
}

export default WebsiteMenu